import { Controller } from '@hotwired/stimulus';

// Rows come from nested_form_template; NEW_RECORD must match NestedFormHelper.
const PLACEHOLDER = /NEW_RECORD/g;
const ROW_SELECTOR = '.nested-fields';

export default class extends Controller {
  static targets = ['container', 'template', 'addLink'];
  static values = { limit: Number, scrollOnAdd: Boolean };

  connect() {
    this.index = Date.now();
    this.hideDestroyedRows();
    this.toggleAddLink();
  }

  // After a failed save, rows already marked for removal come back with _destroy set.
  hideDestroyedRows() {
    this.containerTarget.querySelectorAll(ROW_SELECTOR).forEach((row) => {
      const destroy = row.querySelector('input[name$="[_destroy]"]');
      if (destroy && ['true', '1'].includes(destroy.value))
        row.style.display = 'none';
    });
  }

  add(event) {
    event.preventDefault();
    if (this.hasLimitValue && this.visibleRows().length >= this.limitValue)
      return;

    const fragment = document.createElement('template');
    fragment.innerHTML = this.templateTarget.innerHTML.replace(
      PLACEHOLDER,
      String(this.index++),
    );
    const row = fragment.content.firstElementChild;

    this.containerTarget.append(row);
    if (this.scrollOnAddValue)
      row.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    this.toggleAddLink();
  }

  remove(event) {
    event.preventDefault();

    const row = event.target.closest(ROW_SELECTOR);
    if (row.dataset.newRecord === 'true') {
      row.remove();
    } else {
      row.querySelector('input[name$="[_destroy]"]').value = '1';
      row.style.display = 'none';
    }

    this.toggleAddLink();
  }

  toggleAddLink() {
    if (!this.hasLimitValue || !this.hasAddLinkTarget) return;

    this.addLinkTarget.style.display =
      this.visibleRows().length >= this.limitValue ? 'none' : '';
  }

  visibleRows() {
    return [...this.containerTarget.querySelectorAll(ROW_SELECTOR)].filter(
      (row) => row.style.display !== 'none',
    );
  }
}
